// GAVION commissions: labels and refusal messages shared by every commissions screen.
export const commissionsEn = {
  sources: {
    rep_appointment: "Rep's appointment",
    inbound: "Organic (the client came by himself)",
    referral: "Referral",
    assigned: "Assigned client",
  },
  lines: {
    reception: "Receptionist",
    admin_assistant: "Administrative assistant",
  },
  tiers: {
    essentiel: "Essential",
    avance: "Advanced",
    entreprise: "Enterprise",
  },
  billing: { monthly: "Monthly", annual: "Annual" },
  addon_billing: {
    monthly: "per month",
    per_unit_in_month: "per unit in the month",
  },
  exception_kinds: {
    unpaid: "Unpaid",
    refunded: "Refunded",
    partial: "Partial",
  },
  line_kinds: {
    commission: "Commission",
    bonus: "Bonus",
    adjustment: "Adjustment",
    to_decide: "To decide",
  },
  statement_status: { draft: "Draft", paid: "Paid" },
  errors: {
    forbidden: "Admins only.",
    not_found: "Not found.",
    invalid_deal: "This opportunity is not this client's.",
    invalid_month: "Invalid month for this subscription.",
    invalid_billing: "Choose a billing frequency.",
    invalid_package: "Choose an active package.",
    invalid_annual_amount:
      "Enter the annual amount paid (annual billing only).",
    invalid_addons: "Invalid add-on for this package: %{detail}",
    invalid_services:
      "Invalid recurring service: a name and a monthly amount between 0 and 100,000 $.",
    decision_pending:
      "This statement has a « To decide » line: record the agreed split on the opportunity (Sale steps), then refresh the statement.",
    employment_ended:
      "This person left on %{detail}: this draft pays a month after that date (art. 4.3.2). Refresh the statement before marking it paid.",
    stale_draft:
      "This draft is out of date (a subscription, a sale step or a plan changed): refresh it before marking it paid.",
    invalid_settlement:
      "Choose how it was settled: withheld (written consent), paid back or waived.",
    not_open:
      "A correction now due already cancels this amount: nothing to waive (it is closed at the next payout). If it was paid back or withheld, choose « Paid back » or « Withheld ».",
    not_to_settle:
      "Only a negative adjustment of a paid statement is settled with the employee.",
    already_settled: "This amount is already marked settled.",
    invalid_note: "The note is too long.",
    subscription_exists: "This client already has an active subscription.",
    subscription_cancelled: "This subscription is cancelled.",
    deal_already_subscribed:
      "This opportunity already has a subscription: a « New sale » needs a new opportunity, otherwise choose « Resume ».",
    invalid_continuation:
      "Cannot resume: choose a cancelled subscription of this client, ended before the first paid month and not already resumed, with no opportunity or the original one.",
    invalid_exception: "Invalid exception: an amount for « Partial » only.",
    invalid_fee: "Enter an amount and a note.",
    invalid_discount: "Enter a percentage between 0 and 100.",
    plan_overlap: "This person already has a plan for that period.",
    plan_in_force:
      "This plan is already in force: « %{detail} » no longer changes (the past is never rewritten). Create a new version from this month, or enter an end date.",
    invalid_plan: "Invalid plan: %{detail}.",
    version_date:
      "The new version starts this month or later, after the current plan's start.",
    invalid_cutoff: "Choose an end date in the past or today.",
    invalid_date:
      "Invalid payment date: on or after the statement's end date, and not in the future.",
    invalid_paid_on: "Enter the payout date.",
    draft_exists:
      "A draft statement already exists for this person: refresh it or delete it.",
    statement_locked: "This statement is paid: it no longer changes.",
    sale_steps_admin_only: "Only an admin can change the sale steps.",
    invalid_role_holder: "This role must go to an active user (%{detail}).",
    unknown_report: "Unknown report.",
    managed_by_stripe:
      "Managed by Stripe: change it in Stripe, the sync applies it here.",
    invalid_price_map: "Map the price to one package or one add-on.",
    unknown: "Unexpected error (code: %{code}).",
  },
  errors_detail: {
    invalid_month: {
      overlaps_cancelled:
        "This month falls within a cancelled subscription of this client: choose a first month after its last billed month.",
    },
    invalid_exception: {
      above_mrr: "The amount collected exceeds the MRR billed that month.",
    },
    invalid_continuation: {
      deal: "A resumption keeps the original opportunity: leave the opportunity empty.",
    },
    plan_in_force: {
      delete:
        "This plan is already in force: it cannot be deleted. Enter an end date or an employment end.",
    },
  },
};
